<script setup lang="ts">
definePageMeta({
    key: 'direct-sales-listing-static', // Prevent full page re-rendering on params change
    scrollToTop: (to, from) => {
        const routeBaseName = useRouteBaseName();

        return !isNavigatingBetweenSlpRoutes(routeBaseName(to), routeBaseName(from));
    },
    middleware: 'slp',
});
</script>

<template>
    <Slp />
</template>
